import { Component, OnDestroy, OnInit } from '@angular/core';
import { Platform, ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { BlastRedeemService } from 'src/app/services/blast/blast-redeem.service';
import { AppRateService } from 'src/app/services/general/app-rate.service';
import { AppService } from 'src/app/services/general/app.service';
import { FunctionService } from 'src/app/services/general/function.service';
import { PopupService } from 'src/app/services/general/popup.service';

@Component({
  selector: 'app-blast-credit-redeem',
  templateUrl: './blast-credit-redeem.component.html',
  styleUrls: ['./blast-credit-redeem.component.scss'],
})
export class BlastCreditRedeemComponent  implements OnInit, OnDestroy {

  showStep2: boolean;

  constructor(
    private platform: Platform,
    private translate: TranslateService,
    private modalController: ModalController,
    private appService: AppService,
    private appRateService: AppRateService,
    private blastRedeemService: BlastRedeemService,
    private functionService: FunctionService,
    private popupService: PopupService,
  ) { }

  ngOnInit() {}

  ngOnDestroy(): void {
      
  }

  ionViewWillEnter() {
    this.showStep2 = false;
  }

  /**
   * Dismiss modal
   */
  async dismissModal() {
    if (this.modalController) {
      const modal = await this.modalController.getTop();
      if (modal) { await modal.dismiss(); }
    }
  }

  async appRate() {
    if (this.blastRedeemService.validateRedeemBlastCredit()) {
      if (this.platform.is('hybrid')) {
        await this.popupService.presentLoading();
        await this.appRateService.promptAppRate();
        await this.functionService.delay(5000);
        this.showStep2 = true;
        await this.functionService.delay(1000);
        await this.popupService.dismissLoading();
      } else {
        const alert = await this.popupService.presentAlert(this.translate.instant('BLAST.redeem.app_only'));
        alert.onDidDismiss().then(async () => {
          await this.appService.goStore();
          await this.popupService.dismissAllModal();
        });
      }
    } else {
      this.blastRedeemService.promptError();
    }
  }

  async redeemBlastCreditCall() {
    this.blastRedeemService.redeemBlastCreditCall();
  }

}
